import { render, staticRenderFns } from "./pinglun.vue?vue&type=template&id=47f7fe50&scoped=true&"
import script from "./pinglun.vue?vue&type=script&lang=js&"
export * from "./pinglun.vue?vue&type=script&lang=js&"
import style0 from "./pinglun.vue?vue&type=style&index=0&id=47f7fe50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f7fe50",
  null
  
)

export default component.exports